/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../../src/app/common/wizard/wizard.component';
var styles_WizardComponent = [];
export var RenderType_WizardComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_WizardComponent, data: {} });
function View_WizardComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'li', [['class',
                'nav-item']], null, null, null, null, null)),
        i0.ɵdid(278528, null, 0, i1.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers,
            i0.ElementRef, i0.Renderer], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        i0.ɵpod({ 'active': 0, 'enabled': 1, 'disabled': 2, 'completed': 3 }), (_l()(), i0.ɵted(null, ['\n              '])), (_l()(), i0.ɵeld(0, null, null, 1, 'a', [['class', 'color-step-wizard']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.goToStep(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        (_l()(), i0.ɵted(null, ['\n            ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'nav-item';
        var currVal_1 = _ck(_v, 2, 0, _v.context.$implicit.isActive, !_v.context.$implicit.isDisabled, _v.context.$implicit.isDisabled, _co.isCompleted);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.title;
        _ck(_v, 5, 0, currVal_2);
    });
}
export function View_WizardComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 36, 'div', [['class',
                '']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class', '']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 4, 'ul', [['class', 'nav nav-justified']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_WizardComponent_1)), i0.ɵdid(802816, null, 0, i1.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'div', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), i0.ɵncd(null, 0), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 19, 'div', [['class', 'row']], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-secondary float-left content-botonera-foot'], ['type',
                'button']], [[8, 'hidden', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.cancel() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-secondary float-left content-botonera-foot'],
            ['type', 'button']], [[8, 'hidden', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.previous() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-primary float-right content-botonera-foot'],
            ['type', 'button']], [[8, 'disabled', 0], [8, 'hidden', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.next() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-success float-right content-botonera-foot'],
            ['type', 'button']], [[8, 'disabled', 0], [8, 'hidden', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.complete() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-success float-right content-botonera-foot'],
            ['type', 'button']], [[8, 'hidden', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.print() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-success float-right content-botonera-foot'],
            ['type', 'button']], [[8, 'hidden', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.newWizard() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n'])),
        (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.steps;
        _ck(_v, 7, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.isCompleted;
        _ck(_v, 16, 0, currVal_1);
        var currVal_2 = _co.hasPrevStep;
        _ck(_v, 18, 0, currVal_2);
        var currVal_3 = _co.buttonCancel;
        _ck(_v, 19, 0, currVal_3);
        var currVal_4 = ((!_co.hasPrevStep || !_co.activeStep.showPrev) || _co.activeStep.showBComplete);
        _ck(_v, 21, 0, currVal_4);
        var currVal_5 = _co.buttonPrevious;
        _ck(_v, 22, 0, currVal_5);
        var currVal_6 = !_co.activeStep.isValid;
        var currVal_7 = (!_co.hasNextStep || !_co.activeStep.showNext);
        _ck(_v, 24, 0, currVal_6, currVal_7);
        var currVal_8 = _co.buttonNext;
        _ck(_v, 25, 0, currVal_8);
        var currVal_9 = !_co.activeStep.isValid;
        var currVal_10 = (_co.hasNextStep || _co.activeStep.showBComplete);
        _ck(_v, 27, 0, currVal_9, currVal_10);
        var currVal_11 = _co.buttonDone;
        _ck(_v, 28, 0, currVal_11);
        var currVal_12 = !_co.activeStep.showBComplete;
        _ck(_v, 30, 0, currVal_12);
        var currVal_13 = _co.buttonPrint;
        _ck(_v, 31, 0, currVal_13);
        var currVal_14 = !_co.activeStep.showBComplete;
        _ck(_v, 33, 0, currVal_14);
        var currVal_15 = _co.buttonNew;
        _ck(_v, 34, 0, currVal_15);
    });
}
export function View_WizardComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'form-wizard', [], null, null, null, View_WizardComponent_0, RenderType_WizardComponent)), i0.ɵdid(1163264, null, 1, i2.WizardComponent, [], null, null), i0.ɵqud(603979776, 1, { wizardSteps: 1 })], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var WizardComponentNgFactory = i0.ɵccf('form-wizard', i2.WizardComponent, View_WizardComponent_Host_0, { buttonCancel: 'buttonCancel', buttonNext: 'buttonNext',
    buttonPrevious: 'buttonPrevious', buttonDone: 'buttonDone', buttonPrint: 'buttonPrint',
    buttonNew: 'buttonNew' }, { onStepChanged: 'onStepChanged' }, ['*']);
//# sourceMappingURL=wizard.component.ngfactory.js.map